<template>
    <Sidebar :is_empty="true" />
    <div class="content login-content">
        <div class="inner">

            <Header title="How'd you hear about Motom?" sub_title="Request a DemoPlease fill out the form below and we will be in touch!" />

            <div class="result-content" v-if="result === 'success'">
                <h2 class="success">Thanks!</h2>
                <p>Check your email.</p>
                <div class="submit-wrap">
                    <Button size="40" color="dark-blue" to="/login">Sign in</Button>
                    <p><router-link to="/login">Return to Sign in</router-link></p>
                </div>
            </div>
            
            <Form v-else :schema="schema" @submit="submit" :values="values" v-slot="{ errors, success }" class="form-wrap">
                <p class="desc">We will reach out to your as soon as possible</p>
                <Field type="text" k="email" label="Company email" placeholder="company@email.com" :error_msg="errors.email" :is_success="success.email" @update="update"/>
                <Field type="text" k="company" label="Company name" placeholder="Company" :error_msg="errors.company" :is_success="success.company" @update="update"/>
                <Field type="text" k="name" label="Display name" placeholder="Your name" :error_msg="errors.name" :is_success="success.name" @update="update"/>
                <Field type="select" :select_data="role_select" k="role" label="Your role" placeholder="Your name" :error_msg="errors.role" :is_success="success.role" @update="update"/>
                <div class="submit-wrap">
                    <Button size="40" color="dark-blue" type="submit">Send</Button>
                    <p><router-link to="/login">Return to log in</router-link></p>
                </div>
            </Form>


            <Footer />
        </div>
    </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Field from '@/components/ui/Field.vue';
import Button from '@/components/ui/Button.vue';
import Form from '@/components/ui/Form.vue';

import Header from '@/components/login/Header.vue';
import Footer from '@/components/login/Footer.vue';
import * as yup from 'yup';
import YupPassword from 'yup-password';
YupPassword(yup);

export default {
    name: 'request-for-demo',

    data() {
        return {
            schema: yup.object().shape({
                email: yup.string().required('The email can’t leave as blank').email('Must be a valid email'),
                company: yup.string().required('The company name can’t leave as blank'),
                name: yup.string().required('Your name can’t leave as blank'),
                role: yup.string().required('Your role can’t leave as blank'),
            }),
            values: {
                email: '',
                company: '',
                name: '',
                role: '',
            },
            result: '',
            role_select: [
                'Company Owners',
                'Product Manager',
                'Developers',
                'Designers',
            ]
        }
    },

    components: {
        Header,
        Footer,
        Sidebar,
        Form,
        Field,
        Button,
    },

    methods: {
        update(obj) {
            Object.keys(this.values).forEach(key => {
                if (key === obj.key) this.values[key] = obj.val;
            });
        },

        retry() {
            this.result = '';
            this.text = 'Please enter the email address associated with your Motom Portal account and we’ll send you an email with a link to reset your password.';
        },

        submit() {
            this.result = 'success';
            this.text = '';
        }
    },

}
</script>

<style lang="scss">
    .login-content {
        display: flex;
        align-items: center;
        justify-content: center;

        .result-content {
            margin: 40px 0;
            text-align: center;
            color: var(--black-90);

            h2 {
                font: var(--font-demi-20);
                color: var(--green);
                margin-bottom: 12px;

                &.error {
                    color: var(--alert);
                }
            }
            
        }

        .form-wrap {
            .desc {
                font-size: 12px;
                margin: 0 0 16px;
                color: var(--black-50);
            }
            .ui-input > label {
                &::after {
                    content: ' *';
                    color: var(--alert);
                }
            }
        }


        .submit-wrap {
            margin: 44px 16px ;
            text-align: center;

            .ui-button {
                display: block;
                width: 180px;
                text-align: center;
                margin: 0 auto 16px;
            }

            a {
                font: var(--font-fg-12);
                color: var(--dark-blue);
            }
        }
    }
</style>